





import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Editor as TipTapViewer, Text } from 'tiptap';
import { Bold, Italic, Underline, LinkViewer, Strike } from '@/editor/tiptap/marks';
import {
  ListItemNode,
  BreakNode,
  BulletListNode,
  HeadingNode,
  OrderedListNode,
  ParagraphNode,
  TextDocNode,
  MergeValueNode,
} from '@/editor/tiptap/nodes';
import { EHeadingLevel, ENodeAlign } from '@/editor/types/enums';
import { ProsemirrorViewerRoot } from '@/editor/editor-block-view/components/mixins/prosemirror-viewer-root';
import ProsemirrorWrapper from '@/editor/editor-block/components/ProsemirrorWrapper.vue';

@Component({
  components: {
    ProsemirrorWrapper,
  },
})
export default class ProsemirrorViewerText extends Mixins(ProsemirrorViewerRoot) {
  @Prop() defaultHeading: EHeadingLevel;
  @Prop() defaultAlign: ENodeAlign;

  get textViewer() {
    return {
      content: this.content,
      disableInputRules: false,
      disablePasteRules: false,
      editable: false,
      useBuiltInExtensions: false,
      extensions: [
        new TextDocNode(),
        new ParagraphNode({ defaultAlign: this.defaultAlign }),
        new Text(),
        new Bold(),
        new Italic(),
        new Underline(),
        new Strike(),
        new OrderedListNode(),
        new BulletListNode(),
        new ListItemNode(),
        new MergeValueNode(),
        new LinkViewer(),
        new HeadingNode({
          defaultLevel: this.defaultHeading,
          defaultAlign: this.defaultAlign,
          levels: [
            EHeadingLevel.Heading1,
            EHeadingLevel.Heading2,
            EHeadingLevel.Subheading,
            EHeadingLevel.Label,
          ],
        }),
        new BreakNode(),
      ],
      onInit: this.handleInit,
      dropCursor: {
        color: 'transparent',
      },
    };
  }

  mounted() {
    this.viewer = new TipTapViewer(this.textViewer);
  }

  beforeDestroy() {
    this.viewer.destroy();
  }
}
